import * as React from "react";

function SvgRings(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path d="M16.91 5.1l-.32-1.27c-.26-1.05-1.17-1.78-2.22-1.78h-.4L12.79.57H7.21L6.03 2.06h-.4c-1.05 0-1.96.73-2.22 1.78L3.09 5.1c-.55 2.16-1.23 4.85-1.23 6.11 0 4.67 3.65 8.47 8.15 8.47s8.14-3.8 8.14-8.47c-.01-1.25-.69-3.94-1.24-6.11zM10 18.68c-3.94 0-7.15-3.35-7.15-7.47 0-1.14.67-3.76 1.2-5.87l.32-1.27c.15-.6.66-1.02 1.25-1.02h8.74c.59 0 1.1.42 1.25 1.02l.32 1.27c.54 2.11 1.2 4.73 1.2 5.87.01 4.12-3.19 7.47-7.13 7.47z" />
      <path d="M10 4.45c-3.59 0-6.52 3.04-6.52 6.77 0 3.73 2.92 6.77 6.52 6.77 3.59 0 6.52-3.04 6.52-6.77 0-3.74-2.93-6.77-6.52-6.77zm0 12.54c-3.04 0-5.52-2.59-5.52-5.77 0-3.18 2.47-5.77 5.52-5.77 3.04 0 5.52 2.59 5.52 5.77 0 3.18-2.48 5.77-5.52 5.77z" />
    </svg>
  );
}

export default SvgRings;
